import HtmlV1 from "../../../../components/form_builder/elements/html/HtmlV1.vue";

export default {
  componentName: "fb-html-v1",
  component: HtmlV1,
  defaultAttrs: {
    properties: {
      value: "<div></div>",
      style: {},
      hidden: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
